// extracted by mini-css-extract-plugin
module.exports = {"SKGKContainer":"PromoLinksKgk_SKGKContainer__PJs8Z","SKgkButtonLink":"PromoLinksKgk_SKgkButtonLink__wRWhj"};